import React, { useContext, useState, useEffect } from 'react'
import styled from 'styled-components'
import { getPoolRewardText, getPoolTokenLogoURL, getTokenMetaFromAddress } from 'lottery/util'
import { weiToEth } from 'lottery/constants'
import BigNumber from 'bignumber.js'
import { viewTranscationURL } from 'lottery/constants'
import { AccountContext } from 'contexts/AccountProvider'
import { useHistory } from 'react-router-dom'

const StyledTitle = styled.div`
  text-transform: capitalize;
`

const Styles = styled.div`
  padding: 1rem;
  width: 100%;
  table {
    border: none;
    margin: auto;
    color: #5b3926;
    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      border: none;
      border-bottom: 1px solid #f9cabf;
      padding: 0.5rem;
    }
  }
`
const StyledLink = styled.div`
  color: #5b3926;
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
`

const PoolRow = ({ pool }) => {
  const { getToken } = useContext(AccountContext)
  const [poolRewardText, setPoolRewardText] = useState('')
  const history = useHistory();

  useEffect(() => {
    if (pool) {
      getpoolRewardTextInfo()
    }
  }, [pool])


  const getpoolRewardTextInfo = async () => {
    if (getTokenMetaFromAddress(pool.token)) {
      setPoolRewardText(getPoolRewardText(pool))
    } else {
      const token = await getToken(pool.token)
      const symbol = await token.methods.symbol().call()
      setPoolRewardText(`${getPoolRewardText(pool)} ${symbol}`)
    }
  }

  const handleRoute = () => {
    history.push(`pools/${pool.pid}`)
    return false
  }
  return (
    <tr>
      <td>
        <a
          target="_blank"
          onClick={handleRoute}
          >
          <StyledLink>{pool.name}</StyledLink>
        </a>
      </td>
      <td>
        <img src={getPoolTokenLogoURL(pool)} height="40" alt="dice" />
      </td>
      <td>{poolRewardText}</td>
      <td>{weiToEth(BigNumber(pool.weight))}</td>
      <td>{pool.status === '1' ? 'Active' : 'Inactive'}</td>
      <td>
        <a
          href={viewTranscationURL + pool.transactionHash}
          target="_blank"
        >
          <StyledLink>View</StyledLink>
        </a>
      </td>
    </tr>
  )
}
const Table = ({ data }) => {
  return (
    <table>
      <thead>
        <tr>
          <th>Pool Name</th>
          <th>Currency</th>
          <th>Amount Left</th>
          <th>Weights</th>
          <th>Status</th>
          <th>View Transaction</th>
        </tr>
      </thead>
      <tbody>
        {data.map((pool, i) => {
          return (
            <PoolRow pool={pool} key={i} />
          )
        })}
      </tbody>
    </table>
  )
}

const CustomTable = ({ data }) => {
  return (
    <Styles>
      <Table data={data} />
    </Styles>
  )
}

export default CustomTable
